import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import Tooltip from "@material-ui/core/Tooltip";
import SearchIcon from "@material-ui/icons/Search";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import {
  RightDrawer,
  CheckActionPermission,
} from "../../../../../../Actions/commonAction";
import defaultEmp from "../../../../../../Assets/Images/defaultEmp.svg";
import editIcon from "../../../../../../Assets/newicons/action/edit/outline/edit-outline-16px.svg";

import { ChangeLanguage } from "../../../../../../Actions/LanguageAction";
import "./index.css";
import { getFormattedImageLink } from "../../../../../../Utils";
import security from "../../../../../../Assets/Images/security.svg";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  searchIcon: {
    maxWidth: "414px",
    // marginRight: '20px',
    border: "1px solid #d8d8d8",
    borderRadius: "4px",
    padding: "3px 10px",
  },
});

class PermissionPolicyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      policylist: [],
      search: "",
      searchValue: "",
      message: "",
      datarcv: false,
      permissions: { readOnly: false, editable: false },
    };

    this.onSearch = this.onSearch.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("PermissionPolicyList");
  }

  GetPermissionPolices() {
    const URL = `subscription/getallpermissionpolicy/false`;
    instance.get(URL).then(
      (result) => {
        let policylist = [];
        if (result.data.result.length == 0) {
          this.setState({
            fullcount: 0,
            policylist,
            tempList: policylist,
            datarcv: true,
          });
        } else {
          const fullcount = result.data.result[0]
            ? result.data.result[0].fullcount
            : 0;
          result.data.result.length > 0
            ? (policylist = [...this.state.policylist, ...result.data.result])
            : (policylist = this.state.policylist);
          this.setState({
            fullcount,
            policylist,
            tempList: policylist,
            datarcv: true,
          });
        }
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const [isTrue, permissions] = CheckActionPermission("permissionPolicy");
    if (isTrue) {
      this.setState({ permissions }, () => this.GetPermissionPolices());
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  GetNumberOfEmp = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  HelperSliderFlag(side, flag, text, config) {
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }

    this.props.RightDrawer({
      drawerdata: text,
      open: side,
      side: flag,
      configid: config,
    });
  }

  // ConfirmDelete(id) {
  //     this.props.enqueueSnackbar('Are you sure you want to delete?', {
  //         variant: 'warning',
  //         action: [<Button color="inherit" size="small" onClick={() => this.deletePolicy(id)}>Yes</Button>,
  //         <Button color="inherit" size="small">No</Button>],
  //     });
  // }

  // ConfirmDelete(id) {
  //     this.props.enqueueSnackbar('Are you sure you want to delete?', {
  //         variant: 'warning',
  //         action: [<Button color="inherit" size="small" onClick={() => this.deletePolicy(id)}>Yes</Button>,
  //         <Button color="inherit" size="small">No</Button>],
  //     });
  // }

  // deletePolicy(id) {
  //     const that = this;
  //     instance.delete(`subscription//${id}`).then((result) => {
  //         this.setState({
  //             policylist: [],
  //             offset: 0
  //         }, () => {
  //             that.GetPermissionPolices()
  //         })

  onSearch(e) {
    const policylist = this.state.tempList.filter(
      (item) =>
        item.profilename.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({ searchValue: e.target.value, policylist });
  }

  render() {
    const { classes } = this.props;
    return (
      <IntlProvider locale="en" messages={""}>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <main className="content-outer-wrapper">
            {this.state.datarcv && (
              <div>
                <Helmet>
                  <title>{headersList.Config.PermissionPolicy.header}</title>
                </Helmet>
                <div className={classes.root}>
                  {this.state.policylist && this.state.policylist.length < 1 ? (
                    <Grid
                      container
                      className="config-landing-content-container"
                    >
                      <Grid item xs={12} md={6} sm={12}>
                        <div className="text-align-left">
                          <h5>Concept of Permission policy</h5>
                          <p
                            style={{
                              color: "rgba(0, 0, 0, 0.38)",
                              fontSize: "0.875rem",
                              lineHeight: "1.46429em",
                              padding: "20px 20px 20px 0px",
                            }}
                          >
                            <span>
                              <FormattedMessage
                                id="LbInputSetupIsUnit"
                                defaultMessage="A permission policy will allow you to create role based access limits for everything in your sumHR Account. Here, you can create different types of Permission Roles and then define if that role will have (or not have) access to specific features or pages."
                              />
                            </span>
                          </p>
                          {this.state.permissions.editable ? (
                            <div>
                              <Link to={`./permission_policy/create`}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  type="button"
                                  className="btn createbutton"
                                >
                                  Create
                                </Button>
                              </Link>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={12} md={6} sm={12}>
                        <div className="right">
                          <img src={security} className="width80"></img>
                        </div>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container className="config-table">
                      <Divider light />
                      <Grid container className="">
                        <Grid item xs={12} md={4} sm={4}>
                          {/* <div className="table-status noOfResults">
                          <FormattedMessage id="LbShowingAll" defaultMessage="Showing all" />
                          &nbsp;{this.state.policylist && this.state.policylist.length}&nbsp;
                          {this.state.policylist && this.state.policylist.length > 1 ? (
                            <FormattedMessage
                              id="Lbpermisoinpolicymulti"
                              defaultMessage="policies"
                            />
                          ) : (
                            <FormattedMessage
                              id="Lbpermisoinpolicysingle"
                              defaultMessage="policy"
                            />
                          )}
                        </div> */}
                        </Grid>
                        <Grid item xs={12} md={8} sm={8}>
                          <Grid container justify="flex-end" direction="row">
                            <div style={{ marginRight: 20 }}>
                              <FormControl
                                className={`${classes.searchIcon} searchBox`}
                              >
                                <Input
                                  placeholder="Search"
                                  disableUnderline
                                  value={this.state.searchValue}
                                  fullWidth
                                  onChange={this.onSearch}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      <SearchIcon color="disabled" />
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                            <Grid>
                              {this.state.permissions.editable ? (
                                <div style={{}}>
                                  <Link to={`./permission_policy/create`}>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      type="button"
                                      className="createbutton"
                                    >
                                      Create
                                    </Button>
                                  </Link>
                                </div>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} md={4} sm={4}>
                          <div className="table-status noOfResults">
                            <FormattedMessage
                              id="LbShowingAll"
                              defaultMessage="Showing all"
                            />
                            &nbsp;
                            {this.state.policylist &&
                              this.state.policylist.length}
                            &nbsp;
                            {this.state.policylist &&
                            this.state.policylist.length > 1 ? (
                              <FormattedMessage
                                id="Lbpermisoinpolicymulti"
                                defaultMessage="policies"
                              />
                            ) : (
                              <FormattedMessage
                                id="Lbpermisoinpolicysingle"
                                defaultMessage="policy"
                              />
                            )}
                          </div>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          md={12}
                          sm={12}
                          className="padding-top-8"
                        >
                          <Table className="approvalWorkflow-table">
                            <thead>
                              <tr>
                                <th>
                                  <FormattedMessage
                                    id="Lbpermisionpolicyame"
                                    defaultMessage="Policy Name"
                                  />
                                </th>
                                <th>
                                  <FormattedMessage
                                    id="LbCreatedBy"
                                    defaultMessage="Created By"
                                  />
                                </th>
                                <th>Assigned Employees</th>
                                <th>
                                  <FormattedMessage
                                    id="LbEdit"
                                    defaultMessage="Edit"
                                  />
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.policylist &&
                                this.state.policylist.map((listItem, index) => (
                                  <tr key="index">
                                    <td>
                                      <span>{listItem.profilename}</span>
                                    </td>
                                    <td>
                                      <div className="position-rel">
                                        <div>
                                          <Tooltip
                                            title={listItem.addedbyname}
                                            placement="bottom"
                                          >
                                            {listItem.addedbyimagepath ? (
                                              <img
                                                className="team-img1 vertical-middle"
                                                src={getFormattedImageLink(
                                                  listItem.addedbyimagepath,
                                                )}
                                                height=""
                                              />
                                            ) : (
                                              <img
                                                className="team-img1 vertical-middle"
                                                src={defaultEmp}
                                                height="40"
                                              />
                                            )}
                                          </Tooltip>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <Grid
                                        container
                                        justify="center"
                                        alignItems="center"
                                      >
                                        <div className="avtar-thumb-wrapper-small">
                                          {listItem.assignedEmployeeList
                                            .length > 0 ? (
                                            listItem.assignedEmployeeList.map(
                                              (emp) => (
                                                <Tooltip
                                                  key="ke"
                                                  title={emp.employeename}
                                                  placement="bottom"
                                                >
                                                  <div
                                                    className={
                                                      this.GetNumberOfEmp(
                                                        listItem
                                                          .assignedEmployeeList[0]
                                                          .fullcount,
                                                      ) > 0
                                                        ? "avtar-thumb-blur"
                                                        : "avtar-thumb"
                                                    }
                                                  >
                                                    <Link
                                                      to={`./profile/${emp.employeeid}`}
                                                      target="_blank"
                                                    >
                                                      <div className="avatar-wrapper-small">
                                                        {emp.imagepath ==
                                                        null ? (
                                                          <img
                                                            src={defaultEmp}
                                                            height="40"
                                                            className="team-avatar"
                                                          />
                                                        ) : (
                                                          <img
                                                            src={getFormattedImageLink(
                                                              emp.imagepath,
                                                            )}
                                                            height="40"
                                                            className="team-avatar"
                                                          />
                                                        )}
                                                      </div>
                                                    </Link>
                                                  </div>
                                                </Tooltip>
                                              ),
                                            )
                                          ) : (
                                            <div>
                                              <p
                                                className="small-dark-secondary"
                                                style={{ paddingTop: 14 }}
                                              >
                                                No Employee Assigned
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                        {listItem.assignedEmployeeList.length >
                                        0 ? (
                                          this.GetNumberOfEmp(
                                            listItem.assignedEmployeeList[0]
                                              .fullcount,
                                          ) > 0 ? (
                                            <div
                                              className="additional-count"
                                              onClick={this.HelperSliderFlag.bind(
                                                this,
                                                "right",
                                                true,
                                                "permissionpolicy",
                                                listItem.profileid,
                                              )}
                                            >
                                              <span>
                                                <div className="total-count-small">
                                                  +
                                                  {this.GetNumberOfEmp(
                                                    listItem
                                                      .assignedEmployeeList[0]
                                                      .fullcount,
                                                  )}
                                                </div>
                                              </span>
                                            </div>
                                          ) : (
                                            ""
                                          )
                                        ) : (
                                          ""
                                        )}
                                      </Grid>
                                    </td>
                                    <td className="position-rel">
                                      {this.state.permissions.editable ? (
                                        <Link
                                          to={`./permission_policy/${listItem.profileid}`}
                                        >
                                          <img
                                            src={editIcon}
                                            className="cursour-pointer vertical-middle"
                                          ></img>
                                        </Link>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </div>
              </div>
            )}
          </main>
        )}
      </IntlProvider>
    );
  }
}

PermissionPolicyList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(PermissionPolicyList)));
